/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { slugify } from "./utils/functions";
export function generateSlugInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var autoSlugElements = container.querySelectorAll(".auto-slug");
  for (var i = 0; i < autoSlugElements.length; i++) {
    autoSlugElements[i].addEventListener("change", function (e) {
      e.preventDefault();
      var sourceValue = e.target.value;
      var outputElementId = e.target.dataset.output;
      if (!outputElementId) return console.warn(adminConfig.messages.containerIdNotSpecified);
      var outputElement = document.getElementById(outputElementId);
      if (!outputElement) return console.warn(adminConfig.messages.containerNotExist);
      outputElement.value = slugify(sourceValue);
      outputElement.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  }
  var generateSlugElements = container.querySelectorAll(".generate-slug");
  for (var _i = 0; _i < generateSlugElements.length; _i++) {
    generateSlugElements[_i].addEventListener("click", function (e) {
      e.preventDefault();
      var sourceElementId = e.target.dataset.source;
      var outputElementId = e.target.dataset.output;
      if (!sourceElementId) return console.warn(adminConfig.messages.containerIdNotSpecified);
      if (!outputElementId) return console.warn(adminConfig.messages.containerIdNotSpecified);
      var sourceElement = document.getElementById(sourceElementId);
      var outputElement = document.getElementById(outputElementId);
      if (!sourceElement) return console.warn(adminConfig.messages.containerNotExist);
      if (!outputElement) return console.warn(adminConfig.messages.containerNotExist);
      var sourceValue = sourceElement.value;
      outputElement.value = slugify(sourceValue);
      outputElement.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  }
}